export default {
  en: 'English',
  it: 'Italiano',
};
